(function () {
    'use strict';
    angular
        .module('ib-pmt-summary-other-module')
        .controller('PmtSummaryOtherController', PmtSummaryOtherController);

    PmtSummaryOtherController.$inject = ['$scope'];
    function PmtSummaryOtherController($scope) {
        var vm = this;

    };
})();